class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
        document.getElementById('shopping-cart-line-item-status') ||
        document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    // change sugli input quantità
    this.addEventListener('change', debouncedOnChange.bind(this));

    // click + / -
    this.addEventListener('click', (event) => {
      const el = event.target;
      if (!(el instanceof Element)) return;

      const btn = el.closest('[data-quantity-increment], [data-quantity-decrement]');
      if (!btn) return;

      event.preventDefault();

      const index = btn.dataset.index;
      const input =
          this.querySelector(`[data-quantity-input][data-index="${index}"]`) ||
          document.getElementById(`Drawer-quantity-${index}`);

      if (!input) return;

      const min = parseInt(input.getAttribute('min')) || 0;
      const max = parseInt(input.getAttribute('max')) || Infinity;
      let value = parseInt(input.value) || 0;
      const step = 1;

      if (btn.hasAttribute('data-quantity-increment')) {
        value = Math.min(max, value + step);
      } else {
        value = Math.max(min, value - step);
      }

      input.value = value;
      this.updateQuantityButtons(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.querySelectorAll('[data-quantity-input]').forEach((input) => {
      this.updateQuantityButtons(input);
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  updateQuantityButtons(input) {
    const index = input.dataset.index;
    const min = parseInt(input.getAttribute('min')) || 0;
    const max = parseInt(input.getAttribute('max')) || Infinity;
    const value = parseInt(input.value) || 0;

    // cerca i bottoni + e -
    const decBtn = this.querySelector(`[data-quantity-decrement][data-index="${index}"]`);
    const incBtn = this.querySelector(`[data-quantity-increment][data-index="${index}"]`);

    if (decBtn) {
      decBtn.disabled = value <= min;
    }
    if (incBtn) {
      incBtn.disabled = value >= max;
    }
  }


  resetQuantityInput(id) {
    const inputs =
        this.querySelectorAll(`[data-quantity-input][data-index="${id}"]`);

    const targets = inputs.length
        ? inputs
        : [document.getElementById(`Drawer-quantity-${id}`)].filter(Boolean);

    if (!targets.length) return;

    targets.forEach((input) => {
      input.value = input.getAttribute('value') || input.value;
      this.updateQuantityButtons(input);
    });

    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    event.target.setCustomValidity('');
    event.target.reportValidity();
    this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
    );
  }

  async validateGiftboxCheckbox(event) {
    const target = event.target;
    const line = target.id.split('-')[1];
    const quantity = target.dataset.quantity;

    const lineItem = event.target.closest('.cart-item');

    const propertyInputs = lineItem.querySelectorAll('input[name^="properties"]');

    const properties = {};
    propertyInputs?.forEach((input) => {
      const match = input.name.match(/\[(.*?)\]/);
      const extracted = match ? match[1] : null;
      properties[extracted] = input.value;
    });

    properties['_gift_box'] = `${target.checked}`;

    const item = {
      line: line,
      quantity: quantity,
      properties: properties,
    };

    await fetch(Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(item),
    });
  }

  onChange(event) {
    if (event.target.matches('[data-quantity-input]')) this.validateQuantity(event);
    else if (event.target.matches('[data-giftbox-checkbox]')) this.validateGiftboxCheckbox(event);
  }

  async onCartUpdate() {
    const sections = {
      'CART-DRAWER-ITEMS': {
        'cart-drawer': ['cart-drawer-items', '.cart-drawer__footer'],
      },
      'CART-ITEMS': {
        'enjp-main-cart-items': ['cart-items'],
        'enjp-cart-footer': ['.cart__footer'],
        '#cart-collection': ['[data-cart-collection]'],
      },
    };

    const sectionToRender = Object.keys(sections[this.tagName]);
    const requestUrl = `${routes.cart_url}?sections=${sectionToRender
        .map((section) => section.replace('#', ''))
        .join(',')}`;

    const response = await fetch(requestUrl);
    const responseJSON = await response.json();

    for (let section of sectionToRender) {
      const html = new DOMParser().parseFromString(responseJSON[section.replace('#', '')], 'text/html');
      for (let selector of sections[this.tagName][section]) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) targetElement.replaceWith(sourceElement);
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-mobile',
        section: 'cart-icon-bubble-mobile',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    //this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
                document.getElementById(section.id)?.querySelector(section.selector) ||
                document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1]
              ? parsedState.items[line - 1].quantity
              : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
              document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
                ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                : lineItem.querySelector(`[name="${name}"]`).focus();
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: parsedState,
            variantId: variantId,
          });
        })
        .catch((error) => {
          console.log('CATCH', error);
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
          this.disableLoading(line);
        });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
        document.getElementById('cart-live-region-text') ||
        document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems =
        document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
        overlay.classList.remove('hidden')
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems =
        document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
      'cart-note',
      class CartNote extends HTMLElement {
        constructor() {
          super();

          this.addEventListener(
              'input',
              debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
              }, ON_CHANGE_DEBOUNCE_TIMER)
          );
        }
      }
  );
}
